<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <div style="display:table;">
            <div style="display:table-cell;vertical-align: middle;">
              <img
                width="50px"
                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/メスガキ.png"
                style="border-radius: 25px;"
              >
            </div>
            <div style="display:table-cell;vertical-align: middle;">
              <span>マスターデュエル デッキレシピ管理 Ver1.00</span>
            </div>
          </div>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>

        <!-- <v-btn class="primary" @click="dataSearch()">データ取得</v-btn> -->
        <v-spacer></v-spacer>
      </v-toolbar>
    </div>

    <v-card class="ma-4 pa-2 text-right">
      <v-btn color="primary" dark class="mb-2" @click="editItem()">
        <v-icon>mdi-new-box</v-icon>デッキレシピ新規追加
      </v-btn>
      <v-btn color="red darken-4" dark class="mb-2" @click="filePut()" style="margin-left:20px;">
        <v-icon>mdi-tray-arrow-up</v-icon>本番データ反映
      </v-btn>
    </v-card>

    <v-card class="ma-6"></v-card>
    <v-card class="ma-6">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        clearable
      ></v-text-field>

      <v-data-iterator
        :headers="headers"
        :items="deck_recipe_list"
        :search="search"
        :custom-filter="customFilter2"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [100, 200, 500] }"
      >
        <template v-slot:default="props">
          <ul class="deck_list">
            <li v-for="item in props.items" :key="item.title" color style="border-radius:10px;">
              <v-hover v-slot="{ hover }" open-delay="0">
                <v-card
                  style="margin-bottom: 10px;"
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="green lighten-4 ma-1"
                >
                  <img
                    @click="editItem(item)"
                    v-if="item.deck_image != ''"
                    width="60"
                    :src="item.deck_image"
                    style="box-shadow: 5px 5px 0px 0 #414141;"
                  >
                  <img
                    @click="editItem(item)"
                    v-else
                    width="60"
                    :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/裏面.png'"
                    style="box-shadow: 5px 5px 0px 0 #414141;"
                  >
                  <div @click="editItem(item)" class="anime_title mt-2">{{ item.name }}</div>
                  <div>
                    <v-icon
                      color="green darken-4"
                      large
                      @click="copyToClipboard(item, 'img')"
                    >mdi-image-outline</v-icon>
                    <v-icon
                      color="green darken-4"
                      large
                      @click="copyToClipboard(item, '')"
                    >mdi-image-off</v-icon>
                    <v-icon
                      color="green darken-4"
                      large
                      @click="copyToClipboard2(item)"
                    >mdi-alpha-s-box-outline</v-icon>
                  </div>
                </v-card>
              </v-hover>
            </li>
          </ul>
        </template>
      </v-data-iterator>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog v-model="showDialog" scrollable persistent max-width="1500px">
        <v-card width="800" :disabled="loading">
          <v-overlay :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" style="width:100%">
              <v-col cols="10" style="display:table;">
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left; width: 40px;"
                >
                  <a :href="target_url" target="_blank" v-if="target_deck_image_id != ''">
                    <img width="40" :src="target_deck_image_id">
                  </a>
                  <img
                    width="40"
                    src="https://admin.appmedia.jp/wp-content/themes/appmedia/lib/yugioh/img/all_cards/no_image.webp"
                    v-else
                  >
                </div>
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left;"
                  v-if="target_id != ''"
                >
                  《
                  <a :href="target_url" target="_blank">{{ target_name }}</a>》を編集中
                </div>
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left;"
                  v-else
                >デッキを編集</div>
              </v-col>
              <v-col cols="2" class="text-right">
                <v-btn color="blue darken-1" text @click="closeDialog()" style="font-size:40px;">×</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row>
                <v-col cols="7">
                  <v-tabs center-active v-model="tab" class="pt-0">
                    <v-tab>基本情報</v-tab>
                    <v-tab>評価、コンセプト</v-tab>
                    <v-tab>レシピ編集</v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
              <v-tabs-items v-model="tab" class="pt-0">
                <v-tab-item style="min-height:400px;">
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="デッキ名"
                        hide-details="auto"
                        class="pa-0"
                        :rules="rules"
                        v-model="target_name"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="個別記事URL"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_url"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-select
                        label="デッキタイプ"
                        class="pa-0"
                        :items="deck_type_array"
                        v-model="target_deck_type"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="デッキの強さ"
                        class="pa-0"
                        :items="deck_str_array"
                        v-model="target_deck_strength"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="運用難度"
                        class="pa-0"
                        :items="point_array"
                        v-model="target_deck_play_difficulty"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="構築難度"
                        class="pa-0"
                        :items="point_array"
                        v-model="target_deck_make_difficulty"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <!-- <v-autocomplete
                        v-model="target_deck_image"
                        :items="list2"
                        label="デッキ画像"
                        class="pt-0 pb-0"
                      ></v-autocomplete>-->
                      <v-autocomplete
                        v-model="target_deck_image"
                        :items="top_card_list"
                        outlined
                        dense
                        chips
                        small-chips
                        label="デッキ画像"
                        class="pt-0 pb-0"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="デッキ個別サムネイル"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_deck_thumbnail"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        v-model="target_needed_pack"
                        :items="pack_list"
                        outlined
                        dense
                        chips
                        small-chips
                        label="必須パック"
                        multiple
                        class="pt-0 pb-0"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="ポイント1"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_point1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="ポイント2"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_point2"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="ポイント3"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_point3"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <!-- 評価等_S -->
                <v-tab-item style="min-height:400px;">
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0"
                        auto-grow
                        outlined
                        v-model="target_deck_concept"
                        label="デッキコンセプト"
                        counter="1000"
                        style="overflow: scroll;"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0"
                        auto-grow
                        outlined
                        v-model="target_simple_evaluation"
                        label="簡易評価"
                        counter="1000"
                        style="overflow: scroll;"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <!-- ポイント等_E -->
                <!-- デッキ情報編集画面_S -->
                <v-tab-item style="min-height:400px;">
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%;">
                    <!-- レシピ表示_S -->
                    <v-col cols="6" style="height:500px; overflow: scroll;">
                      <div
                        v-for="(item, index) in deck_recipe_cards"
                        :key="index"
                        class="text-center card_list_item"
                        color
                      >
                        <div v-if="typeof deck_recipe_cards_cnt[index] != 'undefined'">
                          <div class="mt-8" style="font-weight:bold; font-size: 20px;">{{ index }}</div>
                          <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                            <v-col
                              style="display:flex; justify-content:center; align-items:center;"
                            >
                              <img
                                width="20px"
                                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/めいん.png"
                              >
                              <span
                                style="margin-left:10px; font-size:15px;"
                              >{{ deck_recipe_cards_cnt[index]["all"] }}</span>
                            </v-col>
                            <v-col
                              style="display:flex; justify-content:center; align-items:center;"
                            >
                              <img
                                width="20px"
                                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/えくすとら.png"
                              >
                              <span
                                style="margin-left:10px; font-size:15px;"
                              >{{ deck_recipe_cards_cnt[index]["ex"] }}</span>
                            </v-col>
                            <v-col
                              style="display:flex; justify-content:center; align-items:center;"
                            >
                              <img
                                width="20px"
                                src="https://appmedia.jp/wp-content/uploads/2021/11/monster.png"
                              >
                              <span
                                style="margin-left:10px; font-size:15px;"
                              >{{ deck_recipe_cards_cnt[index]["mon"] }}</span>
                            </v-col>
                            <v-col
                              style="display:flex; justify-content:center; align-items:center;"
                            >
                              <img
                                width="20px"
                                src="https://appmedia.jp/wp-content/uploads/2021/11/magic.png"
                              >
                              <span
                                style="margin-left:10px; font-size:15px;"
                              >{{ deck_recipe_cards_cnt[index]["mag"] }}</span>
                            </v-col>
                            <v-col
                              style="display:flex; justify-content:center; align-items:center;"
                            >
                              <img
                                width="20px"
                                src="https://appmedia.jp/wp-content/uploads/2021/11/trap.png"
                              >
                              <span
                                style="margin-left:10px; font-size:15px;"
                              >{{ deck_recipe_cards_cnt[index]["tra"] }}</span>
                            </v-col>
                          </v-row>
                          <draggable
                            class="deck_list indigo lighten-5"
                            tag="ul"
                            v-model="target_recipe[index]"
                            style="border-radius:5px; padding-top:15px;"
                          >
                            <li
                              v-for="(it, idx) in item"
                              :key="idx"
                              class="text-center card_list_item"
                              color
                            >
                              <div @click="delItem2(it,index)">
                                <img
                                  width="50"
                                  :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/' + it.card_id + '.webp'"
                                >
                              </div>
                              <span class="card_name">{{ it.card_name }}</span>
                            </li>
                          </draggable>
                        </div>
                      </div>
                    </v-col>
                    <!-- レシピ表示_E -->
                    <!-- カード一覧_S -->
                    <v-col cols="6">
                      <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                        <v-col>
                          <v-text-field
                            label="デッキレシピ名"
                            hide-details="auto"
                            class="pa-0"
                            v-model="target_deck_recipe_name"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-card class="ma-6" style="margin:0px!important; height:100%">
                        <v-text-field
                          v-model="search2"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          id="data_search"
                          class="mx-4 pa-4"
                          placeholder="検索"
                          clearable
                        ></v-text-field>

                        <v-data-iterator
                          :headers="headers"
                          :items="list"
                          :search="search2"
                          :custom-filter="customFilter"
                          :items-per-page="50"
                          :footer-props="{ itemsPerPageOptions: [50, 100, 500] }"
                        >
                          <template v-slot:default="props">
                            <ul class="deck_list" style="overflow: scroll;">
                              <li
                                v-for="item in props.items"
                                :key="item.id"
                                class="text-center card_list_item"
                                color
                              >
                                <div @click="addRecipe(item)">
                                  <img
                                    width="50"
                                    :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/' + item.id + '.webp'"
                                  >
                                </div>
                                <span class="card_name">{{ item.name }}</span>
                              </li>
                            </ul>
                          </template>
                        </v-data-iterator>
                      </v-card>
                    </v-col>
                    <!-- カード一覧_E -->
                  </v-row>
                </v-tab-item>
                <!-- デッキ情報編集画面_E -->
              </v-tabs-items>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="closeDialog()">閉じる</v-btn>
            <v-row class="pa-4 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="blue" dark @click="saveItem()">更新</v-btn>
              </v-col>
              <v-col cols="12" style="max-width:120px;text-align:right;">
                <v-btn color="red" dark @click="delItem()">削除</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";
// ドラッグアンドドロップ
import draggable from "vuedraggable";

export default {
  components: {
    draggable
  },

  data() {
    return {
      detail_cards_list: [],

      dialog: false,
      confirm_dialog: false,
      overlay: false,

      showDialog: false,

      showDialog2: false,

      loading: false,

      tab: null,

      deck_recipe_list: [],

      pack_list: [],

      top_card_list: [],

      deck_type_array: [
        "-",
        "環境上位デッキ",
        "環境中堅デッキ",
        "環境下位デッキ",
        "その他デッキ",
        "ファンデッキ",
        "未実装デッキ"
      ],

      deck_str_array: [
        "-",
        "展開系デッキ",
        "ビート系デッキ",
        "妨害系デッキ",
        "ワンキル系デッキ",
        "ロマン系デッキ"
      ],

      point_array: ["-", "1", "2", "3", "4", "5"],

      target_id: "",
      target_name: "",
      target_url: "",
      target_deck_image_id: "",
      target_deck_image: "",
      target_point1: "",
      target_point2: "",
      target_point3: "",
      target_deck_concept: "",
      target_simple_evaluation: "",
      target_deck_type: "",
      target_deck_strength: "",
      target_deck_play_difficulty: "",
      target_deck_make_difficulty: "",
      target_deck_thumbnail: "",
      target_search_word: "",
      target_needed_pack: "",
      target_post_type: "",

      // レシピのカード編集時に使う変数
      tmp_target_card_id: "",
      tmp_target_card_name: "",
      // target_leader: "",

      // デッキレシピ
      deck_recipe_cards: [],
      deck_recipe_cards_cnt: [],
      deck_recipe_name: [],
      target_deck_recipe_name: "",
      target_recipe: {},

      target_all_card: 0,
      target_mon_card: 0,
      target_mag_card: 0,
      target_tra_card: 0,
      target_ex_card: 0,

      headers: [],

      rules: [value => !!value || "入力必須"],

      // //検索用パラメータ
      search: "",
      search2: "",

      list: [],

      // // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {
    //カテゴリフィルター
    // filteredItems() {
    //   return this.list.filter((i) => {
    //     if (i.category && this.select_category) {
    //       return i.category == this.select_category;
    //     } else {
    //       return false;
    //     }
    //   });
    // },
  },

  //---------------------------
  // 読み込み時に実行
  //---------------------------
  created: function() {
    // カード一覧
    this.getCardList();
    // パックリスト
    this.getPackList();
    // デッキレシピ一覧
    this.getDeckRecipeList();
  },

  methods: {
    //---------------------------
    // カスタムフィルタ
    //---------------------------
    customFilter: function(items, search) {
      if (search === null || search == "") {
        return items;
      }
      items = items.filter(function(value) {
        if (value.name.indexOf(search) != -1) {
          return true;
        } else if (value.name_kana.indexOf(search) != -1) {
          return true;
        } else {
          return false;
        }
      });
      return items;
    },

    //---------------------------
    // カスタムフィルタ2
    //---------------------------
    customFilter2: function(items, search) {
      if (search === null || search == "") {
        return items;
      }
      items = items.filter(function(value) {
        if (value.name.indexOf(search) != -1) {
          return true;
        } else {
          return false;
        }
      });
      return items;
    },

    //---------------------------
    // D&D
    //---------------------------
    // dd_start(event) {
    //   console.log(event);
    // },
    // dd_end(event) {
    //   console.log(event);
    // },

    //---------------------------
    // カードリスト取得
    //---------------------------
    getCardList() {
      // console.log(keyword);
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/cross_duel_list?table_name=yugioh_MD_card"
        )
        .then(response => {
          const items = [];
          const values = Object.values(response.data);

          values.forEach(value => {
            items.push(value);
            this.top_card_list.push(value.name);
          });
          this.list = items;
        });
    },

    //---------------------------
    // パックリスト取得
    //---------------------------
    getPackList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/cross_duel_list?table_name=yugioh_MD_pack"
        )
        .then(response => {
          // console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            if (value.pack_type != "現実") {
              items.push(value.name);
            }
          });
          this.pack_list = items;
        });
      // console.log(this.skill_list);
    },

    //---------------------------
    // デッキレシピリスト取得
    //---------------------------
    getDeckRecipeList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_db_list?table_name=yugioh_MD_deck"
        )
        .then(response => {
          // console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          //   const tmp_recipe = [];
          values.forEach(value => {
            // const tmp_recipe = JSON.parse(value.recipe);
            // value.recipe = [];
            // value.recipe = tmp_recipe;
            items.push(value);
          });
          this.deck_recipe_list = items;
        });

      // console.log(this.deck_recipe_list);
    },

    //---------------------------
    // カード一覧表示
    //---------------------------
    cardList(name) {
      this.card_list = this.detail_cards_list[name];
    },

    //---------------------------
    // 編集画面
    //---------------------------
    editItem(item) {
      var tmp_deck_image = "";

      this.target_recipe = {};

      if ((item === void 0) === false) {
        this.target_id = item.id;
        this.target_name = item.name;
        this.target_url = item.url;
        this.target_deck_image = item.deck_image;
        this.target_point1 = item.point1;
        this.target_point2 = item.point2;
        this.target_point3 = item.point3;
        this.target_deck_concept = item.deck_concept;
        this.target_simple_evaluation = item.simple_evaluation;
        this.target_deck_type = item.deck_type;
        this.target_deck_strength = item.deck_strength;
        this.target_deck_play_difficulty = item.deck_play_difficulty;
        this.target_deck_make_difficulty = item.deck_make_difficulty;
        this.target_deck_thumbnail = item.deck_thumbnail;

        this.target_deck_image_id = item.deck_image;

        tmp_deck_image = item.deck_image.replace(
          "https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/",
          ""
        );
        tmp_deck_image = tmp_deck_image.replace(".jpg", "");
        this.list.forEach(value => {
          if (value.id == tmp_deck_image) {
            this.target_deck_image = value.name;
            return false;
          }
        });

        this.target_search_word = item.search_word;
        this.target_needed_pack = item.needed_pack;
        this.target_post_type = "update";
        this.deck_recipe_cards = {};

        this.getDeckRecipeCards();
        this.tab = 0;
      } else {
        this.target_id = "";
        this.target_name = "";
        this.target_url = "";
        this.target_deck_image = "";
        this.target_point1 = "";
        this.target_point2 = "";
        this.target_point3 = "";
        this.target_deck_concept = "";
        this.target_simple_evaluation = "";
        this.target_deck_type = "";
        this.target_deck_strength = "";
        this.target_deck_play_difficulty = "";
        this.target_deck_make_difficulty = "";
        this.target_deck_thumbnail = "";
        this.target_search_word = "";
        this.target_needed_pack = "";
        this.target_post_type = "insert";

        this.deck_recipe_cards = {};
      }

      // this.recipeCnt();
      // console.log(this.target_deck_type);
      this.target_recipe = this.deck_recipe_cards;
      console.log(this.target_recipe);

      this.showDialog = true;
    },

    //---------------------------
    // デッキレシピ取得(選択されたデッキのレシピ)
    //---------------------------
    getDeckRecipeCards() {
      // var self = this;
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_deck_recipe_db_list?deck_id=" +
            this.target_id
        )
        .then(response => {
          // console.log(response);
          // v-data-tableを使うときは配列に格納する
          const values = Object.values(response.data);
          var tmp_item = {};
          var tmp_card_type = "";
          var tmp_deck_name = "";
          this.target_all_card = 0;
          this.target_mon_card = 0;
          this.target_mag_card = 0;
          this.target_tra_card = 0;
          this.target_ex_card = 0;

          Object.keys(values).forEach(key => {
            values[key].forEach(elm => {
              // デッキレシピ配列とデッキ枚数配列を初期化
              if (
                typeof this.deck_recipe_cards[elm["recipe_name"]] == "undefined"
              ) {
                this.deck_recipe_cards[elm["recipe_name"]] = [];
              }

              if (tmp_deck_name != elm["recipe_name"] && tmp_deck_name != "") {
                this.target_all_card = 0;
                this.target_mon_card = 0;
                this.target_mag_card = 0;
                this.target_tra_card = 0;
                this.target_ex_card = 0;
              }

              tmp_deck_name = elm["recipe_name"];

              if (elm["attr"] == "罠") {
                tmp_card_type = "trap";
              } else if (elm["attr"] == "魔法") {
                tmp_card_type = "magic";
              } else if (
                elm["monster_type_2"] == "融合" ||
                elm["monster_type_2"] == "シンクロ" ||
                elm["monster_type_2"] == "エクシーズ" ||
                elm["monster_type_2"] == "リンク" ||
                elm["monster_type_2"] == "ペンデュラム儀式" ||
                elm["monster_type_2"] == "ペンデュラム融合" ||
                elm["monster_type_2"] == "ペンデュラムシンクロ" ||
                elm["monster_type_2"] == "ペンデュラムエクシーズ"
              ) {
                tmp_card_type = "ex";
              } else {
                tmp_card_type = "nomal";
              }

              tmp_item = {};

              this.$set(tmp_item, "card_id", elm["card_id"]);
              this.$set(tmp_item, "card_name", elm["name"]);
              this.$set(tmp_item, "card_type", tmp_card_type);

              // カード枚数分繰り返し
              for (var i = 0; i < Number(elm["card_count"]); i++) {
                if (tmp_item["card_type"] == "trap") {
                  this.target_tra_card++;
                  this.target_all_card++;
                } else if (tmp_item["card_type"] == "magic") {
                  this.target_mag_card++;
                  this.target_all_card++;
                } else if (tmp_item["card_type"] == "ex") {
                  this.target_ex_card++;
                } else if (tmp_item["card_type"] == "nomal") {
                  this.target_mon_card++;
                  this.target_all_card++;
                }

                this.deck_recipe_cards[elm["recipe_name"]].push(tmp_item);
              }

              // カード枚数を配列へ
              this.deck_recipe_cards_cnt[elm["recipe_name"]] = {
                all: this.target_all_card,
                mon: this.target_mon_card,
                mag: this.target_mag_card,
                tra: this.target_tra_card,
                ex: this.target_ex_card
              };
            });
          });

          // this.deck_recipe_cards.splice();

          console.log(this.deck_recipe_cards);
          console.log(this.deck_recipe_cards_cnt);

          // 親配列を更新
          this.deck_recipe_list.splice();

          // this.target_recipe = this.deck_recipe_list["ふわんだりぃず"];
        });
    },

    //---------------------------
    // レシピ追加
    //---------------------------
    addRecipe(item) {
      if (this.target_deck_recipe_name == "") {
        alert("デッキレシピ名を指定してください");
        return;
      }

      // デッキレシピ配列とデッキ枚数配列を初期化
      if (
        typeof this.deck_recipe_cards[this.target_deck_recipe_name] ==
        "undefined"
      ) {
        this.deck_recipe_cards[this.target_deck_recipe_name] = [];
        this.target_all_card = 0;
        this.target_mon_card = 0;
        this.target_mag_card = 0;
        this.target_tra_card = 0;
        this.target_ex_card = 0;
      } else {
        this.target_all_card = this.deck_recipe_cards_cnt[
          this.target_deck_recipe_name
        ]["all"];
        this.target_mon_card = this.deck_recipe_cards_cnt[
          this.target_deck_recipe_name
        ]["mon"];
        this.target_mag_card = this.deck_recipe_cards_cnt[
          this.target_deck_recipe_name
        ]["mag"];
        this.target_tra_card = this.deck_recipe_cards_cnt[
          this.target_deck_recipe_name
        ]["tra"];
        this.target_ex_card = this.deck_recipe_cards_cnt[
          this.target_deck_recipe_name
        ]["ex"];
      }

      var tmp_card_type = "";

      if (item["attr"] == "罠") {
        tmp_card_type = "trap";
        this.target_tra_card++;
        this.target_all_card++;
      } else if (item["attr"] == "魔法") {
        tmp_card_type = "magic";
        this.target_mag_card++;
        this.target_all_card++;
      } else if (
        item["monster_type_2"] == "融合" ||
        item["monster_type_2"] == "シンクロ" ||
        item["monster_type_2"] == "エクシーズ" ||
        item["monster_type_2"] == "リンク" ||
        item["monster_type_2"] == "ペンデュラム儀式" ||
        item["monster_type_2"] == "ペンデュラム融合" ||
        item["monster_type_2"] == "ペンデュラムシンクロ" ||
        item["monster_type_2"] == "ペンデュラムエクシーズ"
      ) {
        tmp_card_type = "ex";
        this.target_ex_card++;
      } else {
        tmp_card_type = "nomal";
        this.target_mon_card++;
        this.target_all_card++;
      }

      const tmp = {
        card_id: item["id"],
        card_name: item["name"],
        card_type: tmp_card_type
      };

      this.$set(
        this.deck_recipe_cards[this.target_deck_recipe_name],
        this.deck_recipe_cards[this.target_deck_recipe_name].length,
        tmp
      );

      if (typeof this.deck_recipe_cards_cnt == "undefined") {
        this.deck_recipe_cards_cnt = {};
      }

      // カード枚数を配列へ
      this.deck_recipe_cards_cnt[this.target_deck_recipe_name] = {
        all: this.target_all_card,
        mon: this.target_mon_card,
        mag: this.target_mag_card,
        tra: this.target_tra_card,
        ex: this.target_ex_card
      };

      console.log(this.deck_recipe_cards);

      // 親配列を更新
      this.deck_recipe_list.splice();
    },

    //---------------------------
    // レシピのカード削除
    //---------------------------
    delItem2(item, index) {
      // console.log(item);
      // console.log(index);

      console.log(this.deck_recipe_cards[index]);

      var tmp_deck_recipe_cards = this.deck_recipe_cards[index];
      var flg = false;
      this.deck_recipe_cards[index] = [];

      // カード枚数取得
      this.target_all_card = this.deck_recipe_cards_cnt[index]["all"];
      this.target_mon_card = this.deck_recipe_cards_cnt[index]["mon"];
      this.target_mag_card = this.deck_recipe_cards_cnt[index]["mag"];
      this.target_tra_card = this.deck_recipe_cards_cnt[index]["tra"];
      this.target_ex_card = this.deck_recipe_cards_cnt[index]["ex"];

      // カード枚数更新
      tmp_deck_recipe_cards.forEach(elm => {
        if (item.card_id == elm["card_id"] && flg === false) {
          flg = true;
          // カード枚数カウント
          if (elm["card_type"] == "trap") {
            this.target_tra_card--;
            this.target_all_card--;
          } else if (elm["card_type"] == "magic") {
            this.target_mag_card--;
            this.target_all_card--;
          } else if (elm["card_type"] == "ex") {
            this.target_ex_card--;
          } else {
            this.target_mon_card--;
            this.target_all_card--;
          }
        } else {
          this.$set(
            this.deck_recipe_cards[index],
            this.deck_recipe_cards[index].length,
            elm
          );
        }
      });

      // カード枚数を配列へ
      this.deck_recipe_cards_cnt[index] = {
        all: this.target_all_card,
        mon: this.target_mon_card,
        mag: this.target_mag_card,
        tra: this.target_tra_card,
        ex: this.target_ex_card
      };

      // 親配列を更新
      this.deck_recipe_list.splice();
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      if (this.target_name == "" || this.target_name == null) {
        alert("デッキ名を入力してください");
        return;
      }

      // if (this.target_disp_name == "" || this.target_disp_name == null) {
      //   alert("デッキ名(表示名)を入力してください");
      //   return;
      // }

      // if (
      //   this.target_thumbnail_card_name == "" ||
      //   this.target_thumbnail_card_name == null
      // ) {
      //   alert("デッキ画像を指定してください");
      //   return;
      // }

      var msg = "";
      if (this.target_post_type == "insert") {
        msg = "新規登録";
      } else {
        msg = "更新";
      }
      if (!window.confirm("デッキを" + msg + "します。よろしいですか？")) {
        return;
      }

      this.loading = true;

      // シングルコーテーションをダブルコーテーションに変換
      this.target_point1 = this.target_point1.replace(/'/g, '"');
      this.target_point2 = this.target_point2.replace(/'/g, '"');
      this.target_point3 = this.target_point3.replace(/'/g, '"');

      this.target_deck_concept = this.target_deck_concept.replace(/'/g, '"');
      this.target_simple_evaluation = this.target_simple_evaluation.replace(
        /'/g,
        '"'
      );

      // デッキ画像をカード名から画像パスに
      this.list.forEach(value => {
        if (value.name == this.target_deck_image) {
          this.target_deck_image =
            "https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/" +
            value.id +
            ".jpg";
          return false;
        }
      });

      var item = {
        id: Number(this.target_id),
        name: this.target_name,
        url: this.target_url,
        deck_image: this.target_deck_image,
        point1: this.target_point1,
        point2: this.target_point2,
        point3: this.target_point3,
        deck_concept: this.target_deck_concept,
        simple_evaluation: this.target_simple_evaluation,
        deck_type: this.target_deck_type,
        deck_strength: this.target_deck_strength,
        deck_play_difficulty: this.target_deck_play_difficulty,
        deck_make_difficulty: this.target_deck_make_difficulty,
        deck_thumbnail: this.target_deck_thumbnail,
        search_word: this.target_search_word,
        needed_pack: this.target_needed_pack,
        deck_recipe_cards: this.deck_recipe_cards,
        post_type: this.target_post_type
      };
      console.log(item);

      axios
        .post(process.env.VUE_APP_MD_DECK_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("更新しました！");
          this.showDialog = false;
          this.getDeckRecipeList();
          // this.recipeCnt();
        })
        .catch(error => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
          console.log(error);

          // for (let key of Object.keys(error)) {
          //   console.log(key);
          //   console.log(error[key]);
          // }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // レシピ削除
    //---------------------------
    delItem() {
      if (
        !window.confirm(
          "デッキレシピ《" +
            this.target_name +
            "》を削除します。よろしいですか？"
        )
      ) {
        return;
      }

      var item = {
        id: Number(this.target_id)
      };
      //   console.log(item);

      axios
        .post(process.env.VUE_APP_CD_DECK_RECIPE_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("削除しました！");
          this.showDialog = false;
          this.getDeckRecipeList();
        })
        .catch(error => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.showDialog2 = false;
    },

    //---------------------------
    // jsonファイル出力
    //---------------------------
    filePut() {
      if (!window.confirm("データを反映します。よろしいですか？")) {
        return;
      }

      this.loading = true;

      axios
        .get(process.env.VUE_APP_CD_JSON_UPLOAD)

        .then(() => {
          // console.log(item);
          alert("更新しました！");
          this.showDialog = false;
          // this.dataSearch();
        })
        .catch(error => {
          console.log(error);
          alert("予期せぬエラーが発生しました。\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // クリップボードにURL等をコピー
    //---------------------------
    copyToClipboard(item, type) {
      var text = "";
      if (type == "img") {
        text =
          "<a href='https://admin.appmedia.jp/master_duel/" +
          item.url +
          "'><img class='aligncenter' src='https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/card/" +
          item.thumbnail_card_id +
          ".webp' alt='マスターデュエル_" +
          item.name +
          "' width='60' loading='lazy'>" +
          "</a>";
      } else {
        text =
          "《<a href='https://admin.appmedia.jp/master_duel/" +
          item.url +
          "'>" +
          item.name +
          "</a>》";
      }

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);
    },

    copyToClipboard2(item) {
      var text =
        "[yugioh_md_sc article='deck_info' name='" +
        item.name +
        "' type='' survey_id=''][yugioh_md_deck_tool deck_title='" +
        item.name +
        "' deck_name='']";

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);
    },

    //---------------------------
    // ダイアログ閉じ
    //---------------------------
    closeDialog() {
      this.showDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },
    closeDialog2() {
      this.showDialog2 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    }
  },

  watch: {},

  beforeCreate: function() {}
};
</script>

<style>
.deck_list {
  display: flex;
  flex-wrap: wrap;
}
.deck_list li {
  display: inline-block;
  width: 12%;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
  margin-top: 2px;
}
.leader {
  background-color: #7fffbf;
}
/* .v-btn {
  justify-content: left !important;
} */
</style>
